/**
 * Component: Search page
 * 
 */
'use strict';

export class Search
{
  constructor()
  {
    this.selectors = {
      component:        $('.o-v4-search-results'),
      main:             $('.o-v4-search-results--main'),
      listing:          $('.o-v4-search-results--listing'),

      // Chips
      chips_wrapper:    $('.o-v4-search-results--filters-chips'),
      terms:            $('.o-v4-search-results--filters-chips a.chip-text'),
      reset:            $('.o-v4-search-results--filters-chips a.chip.reset'),
      chip_text_class:  '.o-v4-search-results--filters-chips a.chip-text',

      // Dropdowns
      dropdown_terms:      $('input[type=checkbox].o-v4-search-results--filters-dropdown-term'),
      dropdown_types:      $('input[type=checkbox].o-v4-search-results--filters-dropdown-type'),
      dropdown_toggles:    $('.o-v4-search-results--filters-dropdown .dropdown-toggle'),
      dropdown_totals:     $('.o-v4-search-results--filters-dropdown span.count'),
      dropdown_type_total: $('.o-v4-search-results--filters-dropdown span.count-type'),

      // Misc
      docs_only:           $('.o-v4-search-results--filters-dropdown-docs input[name="documents"]'),
      pagination_links:    '.c-pagination a.page-numbers',
      search_input:        $('.o-v4-search-results--filters-form input[type="text"]'),
      search_input_cancel: $('.o-v4-search-results--filters-form span.before'),

      // Counts
      count_wrapper:    $('.o-v4-search-results--count'),
      count_current:    $('.o-v4-search-results--count span.count-current'),
      count_total:      $('.o-v4-search-results--count span.count-total'),
    };

    /**
     * URL to use for pagination base
     * 
     * @type URL
     */
    this.url            = '';

    /**
     * Taxonomy terms
     * 
     * @type Object
     */
    this.terms          = {};

    /**
     * Post types
     * 
     * @type Array
     */
    this.post_types     = [];

    /**
     * Search string
     * 
     * @type String
     */
    this.search_term         = '';
    this.default_search_term = '';

    /**
     * Page number
     * 
     * @type Number
     */
    this.paged          = 1;

    /**
     * Items per page
     * 
     * @type Number
     */
    this.items_per_page = 10;

    /**
     * Documents-only post types
     * 
     * @type Array
     */
    this.docs_only      = '';
  }

  /**
   * Init
   * 
   */
  init()
  {
    if ( ! this.selectors.component.length ) return;

    this.url                 = this.selectors.main.attr('data-url');
    this.search_term         = this.selectors.search_input.val();
    this.default_search_term = this.selectors.search_input.val();
    this.docs_only           = JSON.parse( this.selectors.main.attr('data-docs-only') );

    this.init_dropdown_terms();
    this.init_dropdown_types();
    this.init_chips();
    this.init_search();
    this.init_pagination();
    this.init_docs_only();
  }

  /**
   * Init dropdown taxonomy inputs
   * 
   */
  init_dropdown_terms()
  {
    let _self = this;

    // Reset
    this.selectors.reset.on('click', ( e ) => {
      e.preventDefault();

      _self.reset();
    });

    this.selectors.dropdown_terms.on('change', function( e )
    {
      $(this).closest( '.dropdown-menu' ).addClass('show');
      $(this).closest( '.dropdown' ).addClass('show');

      if ( $(this).is(':checked') )
      {
        _self.add_term( $(this) );
      }
      else
      {
        _self.remove_term( $(this) );
      }
    });
  }

  /**
   * Init dropdown post types
   * 
   */
  init_dropdown_types()
  {
    let _self = this;

    this.selectors.dropdown_types.on('change', function( e )
    {
      $(this).closest( '.dropdown-menu' ).addClass('show');
      $(this).closest( '.dropdown' ).addClass('show');
      
      _self.update_type_chips();
    });
  }

  /**
   * Init chips
   * 
   */
  init_chips()
  {
    let _self = this;

    $('body').on('click', this.selectors.chip_text_class, function( e )
    {
      e.preventDefault();

      if ( $(this).attr('data-type') == 'post_type' )
      {
        _self.remove_type( $(this) );
      }
      else
      {
        _self.remove_term( $(this) );
      }
    });

    this.selectors.reset.on('click', () => _self.reset() );
  }

  /**
   * Debounce
   *
   * @link https://davidwalsh.name/javascript-debounce-function
   * 
   * @param  function func
   * @param  integer  wait
   * @param  boolean  immediate
   * @return function
   */
  debounce( func, wait, immediate )
  {
    var timeout;

    return function()
    {
        var context = this, args = arguments;
        var later   = function()
        {
            timeout = null;

            if ( ! immediate ) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if ( callNow ) func.apply(context, args);
    };
  };

  /**
   * Init search
   * 
   */
  init_search()
  {
    let _self = this;

    this.selectors.search_input_cancel.on('click', function()
    {
      _self.selectors.search_input.val('');

      _self.search_term = '';
      _self.paged       = 1;

      _self.update_state( false );
      _self.make_ajax_request();
    });

    this.selectors.search_input.on( 'keyup input', this.debounce( function()
    {
      _self.search_term = $(this).val().trim();
      _self.paged       = 1;

      _self.update_state( false );    
      _self.make_ajax_request();
    }, 150 ) );

    this.selectors.search_input.on( 'keyup input', function()
    {
      _self.search_term = $(this).val().trim();
     
      if ( _self.search_term != '' )
      {
        _self.selectors.search_input.parent().addClass('active');
      } 
      else
      {
        _self.selectors.search_input.parent().removeClass('active');
      }
    });
  }

  /**
   * Init pagination
   * 
   */
  init_pagination()
  {
    let _self = this;

    $('body').on('click', _self.selectors.pagination_links, function( e )
    {
      e.preventDefault();

      // Get current page num
      let current = parseInt( $(this).parent().find('span.current').html() );

      // Get page num
      _self.paged = $(this).html();

      if ( $(this).hasClass('prev') )
      {
        _self.paged = current - 1;
      }
      else if ( $(this).hasClass('next') )
      {
        _self.paged = current + 1;
      }

      _self.back_to_top();
      _self.update_state( false );
      _self.make_ajax_request(); 
    });
  }

  /**
   * Documents only filter
   * 
   */
  init_docs_only()
  {
    let _self = this;

    this.selectors.docs_only.on('change', function()
    {
      if ( $(this).is(':checked') )
      {
        // Merge
        _self.post_types = [..._self.post_types, ..._self.docs_only];

        // Check document-only post types
        _self.selectors.dropdown_types.filter(function()
        {
          return _self.post_types.includes( $(this).attr('data-post-type') );
        }).prop('checked', true);
      }
      else
      {
        // Get post types 
        _self.post_types = _self.post_types.filter(function( e )
        {
          return ! _self.docs_only.includes( e );
        });

        // Uncheck all document-only post types
        _self.selectors.dropdown_types.filter(function()
        {
          return ! _self.post_types.includes( $(this).attr('data-post-type') );
        }).prop('checked', false);
      }

      _self.update_type_chips();
    });
  }

  /**
   * Add term
   * 
   */
  add_term( el )
  {
    let _self    = this,
        taxonomy = el.attr('data-taxonomy'),
        term     = el.attr('data-term'),
        label    = el.val(),
        chip     = '<a href="#" class="chip-text filter has-close mr-2" data-taxonomy="' + taxonomy + '" data-term="' + term + '">' + label + '</a>';

    // If taxonomy key does not exist yet, add it
    if ( ! ( taxonomy in _self.terms ) )
    {
      _self.terms[taxonomy] = [];
    }

    // If terms is not in the stack, add it
    if ( _self.terms[taxonomy].includes( term ) === false )
    {
      _self.terms[taxonomy].push( term );
      _self.selectors.chips_wrapper.append( chip );
      _self.selectors.reset.addClass('active');

      _self.paged = 1;
      
      _self.back_to_top();
      _self.make_ajax_request();
    }
  }

  /**
   * Remove term
   * 
   */
  remove_term( el )
  {
    let _self    = this,
        taxonomy = el.attr('data-taxonomy'),
        term     = el.attr('data-term');

    _self.selectors.dropdown_terms.filter( function()
    {
      return ( $(this).attr('data-taxonomy') == taxonomy && $(this).attr('data-term') == term );
    }).prop('checked', false);

    // Remove taxonomy term
    _self.terms[taxonomy] = _self.terms[taxonomy].filter( function ( e )
    {
      return e !== term;
    });

    // Remove chip
    _self.selectors.chips_wrapper.find('a.chip-text.filter').filter( function()
    {
      return ( $(this).attr('data-taxonomy') == taxonomy && $(this).attr('data-term') == term );
    }).remove();

    // Remove taxonomy if empty
    for ( let key in _self.terms )
    {
      if ( _self.terms[key].length === 0 )
      {
        delete _self.terms[key];
      }
    }

    _self.paged = 1;

    _self.back_to_top();
    _self.make_ajax_request();
  }

  /**
   * Update Type chips
   * 
   */
  update_type_chips()
  {
    this.selectors.chips_wrapper.find('a.chip-text[data-type="post_type"]').remove();

    this.post_types = [];

    var _self     = this,
        selected  = this.selectors.dropdown_types.filter(function()
        {
          return $(this).is(':checked');
        });

    // Add chips for each checked option
    selected.each(function( k, el )
    {
      let chip = '<a href="#" class="chip-text filter has-close mr-2" data-type="post_type" data-post-type="' + $(el).attr('data-post-type') + '">' + $(el).val() + '</a>';

      _self.post_types.push( $(this).attr('data-post-type') );
      _self.selectors.chips_wrapper.append( chip );
    });

    this.paged = 1;
    
    this.back_to_top();
    this.make_ajax_request();
  }

  /**
   * Remove Type chip
   * 
   */
  remove_type( el )
  {
    this.post_types = this.post_types.filter( ( e ) => {
      return e !== el.attr('data-post-type');
    });

    // Remove checked status
    this.selectors.dropdown_types.filter( function()
    {
      return ( $(this).attr('data-post-type') == el.attr('data-post-type') );
    }).prop('checked', false);

    // Remove chip
    this.selectors.chips_wrapper.find('a.chip-text.filter').filter( function()
    {
      return ( $(this).attr('data-type') == 'post_type' &&
               $(this).attr('data-post-type') == el.attr('data-post-type') );
    }).remove();

    this.paged = 1;
      
    this.back_to_top();
    this.make_ajax_request();
  }

  /**
   * Update dropdown total counts
   * 
   */
  update_totals()
  {
    let _self = this;

    _self.selectors.dropdown_totals.html('');
    _self.selectors.dropdown_type_total.html('');

    if ( ! $.isEmptyObject( this.terms ) )
    {
      for ( let k in this.terms )
      {
        _self.selectors.dropdown_totals.filter(function()
        {
          return $(this).attr('data-taxonomy') == k;
        }).html('(' + this.terms[k].length + ')');
      };
    }

    if ( this.post_types.length > 0 )
    {
      _self.selectors.dropdown_type_total.html( '(' + _self.post_types.length + ')' );
    }
  }

  /**
   * Reset
   * 
   */
  reset()
  {
    this.selectors.chips_wrapper.find('a.chip-text').remove();
    this.selectors.search_input.val( this.default_search_term );
    this.selectors.dropdown_terms.prop('checked', false);
    this.selectors.dropdown_types.prop('checked', false);
    this.selectors.docs_only.prop('checked', false);

    this.paged       = 1;
    this.terms       = {};
    this.search_term = this.default_search_term;
    this.post_types  = [];

    this.back_to_top();
    this.update_state( true );
    this.make_ajax_request();
  }

  /**
   * Back to top of component
   * 
   */
  back_to_top()
  {
    scroll({
      top:      this.selectors.listing.offset().top - 500,
      behavior: 'smooth'
    });
  }

  /**
   * Update history state
   *
   * @param boolean is_default
   */
  update_state( is_default )
  {
    if ( is_default )
    {
      window.history.replaceState( null, null, this.url + '?s=' + this.search_term );
    }
    else
    {
      window.history.replaceState( null, null, this.url + '/page/' + this.paged + '?s=' + this.search_term );
    }
  }

  /**
   * Update current and total counts
   * 
   */
  update_count()
  {
    var current = window.count_current;

    if ( window.count_total == 0 )
    {
      current = 0;
    }
    else if ( window.count_current < window.count_total )
    {
      current = ( this.paged == 1 ) ? window.count_current : ( window.count_current - ( this.items_per_page - 1 ) ) + '-' + window.count_current;
    }

    // Set last page count
    else if ( window.count_current == window.count_total )
    {
      if ( window.count_current == 0 )
      {
        current = 0;
      }
      else
      {
        let remainder = window.count_total % this.items_per_page ;

        current = ( window.count_total - remainder + 1 ) + '-' + window.count_total;
      }
    }
    
    this.selectors.count_current.html( current );
    this.selectors.count_total.html( window.count_total );
  }

  /**
   * Check whether filters are active and display reset chips
   * 
   */
  check_filtered_status()
  {
    if ( ! $.isEmptyObject( this.terms ) || this.post_types.length > 0 || this.selectors.docs_only.is(':checked') )
    {
      this.selectors.chips_wrapper.addClass('active');
      this.selectors.count_wrapper.addClass('active');
    }
    else
    {
      this.selectors.chips_wrapper.removeClass('active');

      if ( this.selectors.search_input.val() == '' )
      {
        this.selectors.count_wrapper.removeClass('active');
      }
      else
      {
        this.selectors.count_wrapper.addClass('active');
      }
    }
  }

  /**
   * Make ajax request
   * 
   */
  make_ajax_request()
  {
    let _self = this;

    this.check_filtered_status();
    this.update_totals();

    $.ajax({
      type:    'POST',
      url:     sysdigLocalizedObject.ajaxUrl,
      data:    {
        action:     'sysdig_v4_filter__search',
        paged:      _self.paged,
        url:        _self.url,
        terms:      _self.terms,
        search:     _self.search_term,
        post_types: _self.post_types,
      },
      success: function( resp )
      {
        _self.selectors.listing.html( resp );

        _self.update_count();
      }
    });
  }
}
